import { useState, useEffect, useCallback } from 'react';
import { getCurrentLocations } from '../api/locations';
import { useSocket } from '../context/SocketContext';

export function useLocations() {
  const [locations, setLocations] = useState({});
  const { socket } = useSocket();

  const loadCurrent = useCallback(async () => {
    try {
      const data = await getCurrentLocations();
      const map = {};
      data.locations.forEach(loc => { map[loc.user_id] = loc; });
      setLocations(map);
    } catch {}
  }, []);

  useEffect(() => { loadCurrent(); }, [loadCurrent]);

  useEffect(() => {
    if (!socket) return;
    socket.on('location:updated', (loc) => {
      setLocations(prev => ({ ...prev, [loc.userId]: { ...loc, user_id: loc.userId } }));
    });
    return () => socket.off('location:updated');
  }, [socket]);

  return { locations };
}
